/**
 * What this installation is called and where it lives. Read once at start;
 * the wordmark, the document title and every footer come from here, never
 * from a constant in code (docs/design/DYNAMIC_MISSIONS_PLAN.md, section 0).
 */
export interface Meta {
  name: string;
  publicBaseUrl: string;
  version: string;
  panelConfigured: boolean;
  /** The front page's host, served by the platform too; the app renders the front page there. */
  rootHost?: string;
  /** The panel's public host, to link to once the session is shared. */
  panelHost?: string;
  /** The line under the mark on the front page. */
  tagline?: string;
  features: {
    steam: boolean;
    discord: boolean;
  };
}

export const FALLBACK_META: Meta = {
  name: 'SALC',
  publicBaseUrl: '',
  version: 'dev',
  panelConfigured: false,
  features: { steam: false, discord: false },
};

export async function fetchMeta(fetchImpl: typeof fetch = fetch): Promise<Meta> {
  const response = await fetchImpl('/api/meta', { credentials: 'same-origin' });
  if (!response.ok) {
    throw new Error(`GET /api/meta failed: ${response.status}`);
  }
  return (await response.json()) as Meta;
}
